import dateFormat from '@/common/filters/date-format.js';
var pfx = ["webkit", "moz", "MS", "o", ""];
const mixin = {
  computed:{

  },
  methods: {
    keys(obj) {
    
    	let arr = [];
    
    	for (var prop in obj) {
    
    		arr.push(prop);
    
    	};
    
    	return arr;
    
    },
    values(obj) {
    
    	let arr = [];
    
    	for (var prop in obj) {
    
    		arr.push(obj[prop]);
    
    	};
    
    	return arr;
    
    },
    initArray(length,initValue){
      
      let arr=[];
      
      for(let i=0;i<length;i++){
        
        arr[i]=initValue;
        
      };
      
      return arr;
      
    },
    regEmail(email){
      const emailReg=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailReg.test(email);
    },
    verifyMember(member,value){
      return (member & 15) ===value;
    },
    verifySourcePermission(member,value){
      return (member & value)===value;
    },
    memberHandler(member){
      const merberships=[
        {value:1,label:'BRONZE',_class:'icon-medal bronze'},
        {value:2,label:'SILVER',_class:'icon-medal silver light'},
        {value:3,label:'GOLD',_class:'icon-medal gold'},
        {value:4,label:'PRO',_class:'fa fa-shield navbar-fa-shield-pro'},
        {value:5,label:'GLOBAL',_class:'fa fa-shield badge-global'},
        {value:6,label:'GLOBAL_PLUS',_class:'fa fa-shield badge-global-plus'},
        {value:7,label:'GLOBAL_LUXURY',_class:'fa fa-shield badge-global-luxury'},
        {value:8,label:'GLOBAL_DELUXE',_class:'fa fa-shield badge-global-deluxe'}
      ];

      const findMember=merberships.find(item=>this.verifyMember(member,item.value));

      return findMember?`<i class="${findMember._class}" style="font-size: 13px;font-weight: 600;">${findMember.label}</i>`:'';

    },
    fullScreenLoading(loadingText){
      return this.$loading({
        lock: true,
        text:loadingText?loadingText:this.$t('EMAIL_PART_SENDING'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    errorHandler(res){
      res=res.code?res:res.data;
      let code=1;
      let specialCode=[401,402];
      switch (true) {
        case res.code>=10001 && res.code<=10004:
          code=10004;
          break;
        default:
          code=res.code;
          break;
      }
      return specialCode.includes(code)?null:this.$t(code);
    },
    responseHandler(code){
      const message=this.errorHandler({code:code});
      message?this.errorNotify(message):'';
    },
    animationListener(element,type,callback){
      for (var p = 0; p < pfx.length; p++) {
          if (!pfx[p]) type = type.toLowerCase();
          element.addEventListener(pfx[p]+type,callback);
      }
    },
    formatOrigin(key) {
      let label;
      switch (key) {
        case 0:
          label = this.$t('EXTERNAL_CUSTOMERS');
          break;
        case 1:
          label = this.$t('TRADE_INFOMATION');
          break;
        case 2:
          label = this.$t('GLOBAL_BUYERS');
          break;
        case 3:
          label = this.$t('HEADER_SO_SEARCH');
          break;
      }
      ;
      return label;
    },
    toSourcePage(row,key){
      let origin;
      if(!this.isEmpty(key)){
        origin=key;
      }else{
        const rawOrigin=this.formatRawOrigin(row,false);
        origin=rawOrigin.find(item=>item===1 || item===3);
      };
      switch (origin) {
        case 1:
          const params = this.getCompanyParams(row.originCdUuid?row.originCdUuid:row.originComUuid,row.cdDataOrigin);
          window.open(this.$store.state.oemCompany.dataDomain + '/#/shipments/company/' + params.id + '?q=' + params.q, '_blank')
          break;
        case 3:
          const {href}=this.$router.resolve({
            path:'/so/company',query:{q:this.$paramsService.encode({uuid:row.originSoUuid})}
          })
          window.open(href, "_blank");
          break;
        default:
          break;
      }
    },
    tradeSOValueProps(){
      return [
        {prop:'name',label:'SO_COMPANY_INFO_NAME',tProp:'name'},
        {prop:'legal name',label:'SO_COMPANY_FULL_NAME',tProp:'fullName'},
        {prop:'website',label:'SO_COMPANY_INFO_WEBSITE',tProp:'website'},
        {prop:'address',label:'SO_COMPANY_INFO_ADDRESS',tProp:''},
        {prop:['phone','phone number'],label:'SO_COMPANY_INFO_PHONE',tProp:''},
        {prop:'contact',label:'SO_COMPANY_INFO_CONTACT',tProp:''},
        {prop:'contact email',label:'SO_COMPANY_INFO_EAMIL',tProp:''},
        {prop:['founded','founded date'],label:'SO_COMPANY_INFO_FOUNDEDATE',tProp:''},
        {prop:'founders',label:'SO_COMPANY_INFO_FOUNDERS',tProp:''},
        {prop:['headquarters','hq','headquarters regions'],label:'SO_COMPANY_INFO_HQ',tProp:''},
        {prop:'subsidiaries',label:'SO_COMPANY_CHILD_OF_COMPANY',tProp:''},
        {prop:['type','company type'],label:'SO_COMPANY_INFO_TYPE',tProp:''},
        {prop:'categories',label:'SO_COMPANY_INFO_INDUSTRY',tProp:''},
        {prop:'tags',label:'SO_COMPANY_INFO_TAG',tProp:''},
        {prop:'key_people',label:'SO_COMPANY_INFO_KEY_PEOPLE',tProp:''},
        {prop:'description',label:'SO_COMPANY_INFO_DESCRIPTION',tProp:''},
        {prop:'operating status',label:'SO_COMPANY_INFO_OPERATINGSTATUS',tProp:''},
        {prop:'funding status',label:'SO_COMPANY_INFO_FUNDINGSTATUS',tProp:''},
        {prop:'last funding type',label:'SO_COMPANY_INFO_LASTFUNDINGTYPE',tProp:''},
        {prop:'ipo status',label:'SO_COMPANY_INFO_IPOSTATUS',tProp:''},
        {prop:'investment stage',label:'SO_COMPANY_INFO_INVESTMENTSTAGE',tProp:''},
        {prop:'stock price',label:'SO_COMPANY_INFO_STOCKPRICE',tProp:''},
        {prop:'revenue',label:'SO_COMPANY_INFO_REVENUEFY2019',tProp:''},
        {prop:['employees','number of employees'],label:'SO_COMPANY_INFO_NUMBEROFEMPLOYEES',tProp:''},
        {prop:'employee ratings',label:'SO_COMPANY_INFO_EMPLOYEERATINGS',tProp:''},
        {prop:'job openings',label:'SO_COMPANY_INFO_JOBOPENINGS',tProp:''},
        {prop:'ceo',label:'SO_COMPANY_INFO_CEO',tProp:''},
        {prop:'hours',label:'SO_COMPANY_INFO_HOURS',tProp:''}
      ]
    },
    shipmentValueProps(){
      return [
        {prop:'name',label:'CRM_CORPORATE_NAME'},
        {prop:'email',label:'EMAIL'},
        {prop:'contact',label:'SO_CONTACT_METHOD'},
        {prop:'address',label:'COMPANY_ADDRESS'}
      ]
    },
    transformOrigin(prop){
      let key;
      switch (prop) {
        case 'others':
          key=0;
          break;
        case 'originCdUuid':
          key=1;
          break;
        case 'originGbUuid':
          key=2;
          break;
        case 'originSoUuid':
          key=3;
          break;
      }
      return key;
    },
    formatRawOrigin(raw={},label=true){
      let rawLabel=[];
      let origins=[];
      let originProps=['originCdUuid','originGbUuid','originSoUuid'];
      originProps.forEach(prop=>{
        this.isEmpty(raw[prop])?'':(rawLabel.push(this.formatOrigin(this.transformOrigin(prop))),origins.push(this.transformOrigin(prop)));
      });
      if(!label){
        if(this.isEmpty(origins)){
          origins.push(this.transformOrigin('others'));
        }
        return origins;
      };
      if(!this.isEmpty(rawLabel))return rawLabel.join(',');
      rawLabel.push(this.formatOrigin(this.transformOrigin('others')));
      return rawLabel.join(',');
    },
    formatWeek(n) {
      let label, enLabel;
      switch (n) {
        case 0:
          label = '日';
          enLabel = 'Sunday';
          break;
        case 1:
          label = '一';
          enLabel = 'Monday';
          break;
        case 2:
          label = '二';
          enLabel = 'Tuesday';
          break;
        case 3:
          label = '三';
          enLabel = 'Wednesday';
          break;
        case 4:
          label = '四';
          enLabel = 'Thursday';
          break;
        case 5:
          label = '五';
          enLabel = 'Friday';
          break;
        case 6:
          label = '六';
          enLabel = 'Saturday';
          break;
      }
      ;
      return {zh: label, en: enLabel};
    },
    debounce(fn, delay) {
      var timer;
      return function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          timer = null;
          fn ? fn.apply(this, arguments) : '';
        }, delay || 0);
      }
    },
    AmericaDataStructure(){
      return{
        container:{
          allKeys: ['Container/Equipment', 'Cargo Description', 'Tariff Information', 'Additional Cargo Description', 'HAZMAT', 'HAZMAT Classification', 'Marks/Numbers'],
          containerKeys: {keys: ['Container/Equipment', 'Marks/Numbers'],
            items: [
              {key: 'sealNumber', path:'Seal Number'},
              {key: 'serviceType', path:'Type of Service.explanation'},
              {key: 'marks', path:'Marks and Numbers'},
              {key: 'length width height', path: ['Container Length.value','Container Width.value','Container Height.value'], join: ' '},
              // {key: 'containerType', path:'Container Type.value'},
              {key: 'LoadStatus', path:'Load Status.explanation'},
            ]
          },
          descriptionKeys: {keys: ['Cargo Description', 'Tariff Information', 'Additional Cargo Description'],
            items: [
              {key: 'pieceCount', path:'Piece Count'},
              {key: 'description', path:'Description Text'},
              {key: 'additionalDescription', path:'Additional Description'},
              {key: 'Tariff', path:'Tariff Area'},
            ],
            Harmonized:[
              {key: 'Harmonized', path: [
                  {key: 'number',value: 'Harmonized Number'},
                  {key: 'value',value: 'Harmonized Value'},
                  {key: 'weight',value: 'Harmonized Weight'},
                  {key: '',value: 'Harmonized Weight Unit.value'}],
                keyJoin: true},
            ]
          },
          hazmatKeys: {keys: ['HAZMAT', 'HAZMAT Classification'],
            items: [
              {key: 'Code', path:'HAZMAT Code'},
              {key: 'CodeQualifier', path:'HAZMAT Code Qualifier'},
              {key: 'Class', path:'HAZMAT Class'},
              {key: 'Contact', path:'HAZMAT Contact'},
              {key: 'PageNumber', path:'HAZMAT Page Number'},
              {key: 'Temperature', path:'HAZMAT Flash Point Temperature'},
              {key: 'TemperatureNegativeInd', path:'HAZMAT Flash Point Temperature Negative Ind'},
              {key: 'TemperatureUnit', path:'HAZMAT Flash Point Temperature Unit'},
              {key: 'Description', path:'HAZMAT Description'},
              {key: 'Classification', path:'HAZMAT Classification'}
            ]
          }
        },
        others:[
          {key: 'voyageNumber', path: 'BOL identification.Voyage Number'},
          {key: 'billType', path: 'BOL identification.Bill Type Code.explanation'},
          {key: 'vesselCountry', path: 'BOL header.Vessel Country Code.explanation'},
          {key: 'estimatedDate', path: 'BOL header.Estimated Arrival Date.value'},
          {key: 'measurement', path: 'BOL header.Measurement'},
          {key: 'measurementUnit', path: 'BOL header.Measurement Unit.explanation'},
          {key: 'recordStatus', path: 'BOL header.Record Status Indicator.explanation'},
          {key: 'loadingPlace', path: 'BOL header.Place of Receipt'},
          {key: 'unloadingPort', path: 'BOL header.Port of Destination.explanation'},
          {key: 'foreignUnloadingPort', path: 'BOL header.Foreign Port of Destination.explanation'},
          {key: 'conveyanceID', path: {key: 'BOL header.Conveyance ID Qualifier.explanation',value: 'BOL header.Conveyance ID'}, merge: true},
          {key: 'inBondEntryType', path: 'BOL header.In-bond Entry Type.explanation'},
          {key: 'secondaryNotifyParty', path: 'BOL header.Secondary Notify Party.explanation'},
          {key: 'shipperCity', path: 'Shipper.City'},
          {key: 'shipperState', path: 'Shipper.State/Province'},
          {key: 'shipperZipCode', path: 'Shipper.Zip Code'},
          {key: 'shippperCountry', path: 'Shipper.Country Code.explanation'},
          {key: 'ShipperContactName', path: 'Shipper.Contact Name'},
          {key: 'consigneeCity', path: 'Consignee.City'},
          {key: 'consigneeState', path: 'Consignee.State/Province'},
          {key: 'consigneeZipCode', path: 'Consignee.Zip Code'},
          {key: 'consigneeCountry', path: 'Consignee.Country Code.explanation'},
          {key: 'consigneeContactName', path: 'Consignee.Contact Name'},
          {key: 'notifyPartyName', path: 'Notify Party.Notify Party Name'},
          {key: 'notifyPartyAddress', path: 'Notify Party.Notify Party Address'},
          {key: 'notifyPartyCity', path: 'Notify Party.City'},
          {key: 'notifyPartyState', path: 'Notify Party.State/Province'},
          {key: 'notifyPartyZipCode', path: 'Notify Party.Zip Code'},
          {key: 'notifyPartyCountry', path: 'Notify Party.Country Code.explanation'},
          {key: 'notifyPartyContactName', path: 'Notify Party.Contact Name'},
          {key: 'notifyPartyCommNumber', path: {key: 'Notify Party.Comm Number Qualifier.explanation',value: 'Notify Party.Comm Number'}, merge: true}
        ]
      }
    },
    formatAmericaDataItem(format,data){
      function customizer(objValue, srcValue) {
        if (_.isArray(objValue)) {
          return objValue.concat(srcValue);
        }
      };
      var result = {};
      if (_.isArray(data)){
        var temp = {};
        _.forEach(data, function (item) {
          _.mergeWith(temp, item, customizer);
        });
        data = temp;
      }
      _.forEach(format, function (item) {
        var key,value;
        if (item.merge){
          key = _.get(data, item.path.key);
          value = _.get(data, item.path.value);
        } else if(item.join){
          key = item.key;
          value = _.join(_.map(item.path, function (mPath) {
            return _.get(data, mPath);
          }), item.join);
        } else if(item.keyJoin){
          key = item.key;
          value = _.join(_.uniq(_.map(item.path, function (mp) {
            if (_.get(data, mp.value)) {
              return mp.key+':'+_.get(data, mp.value);
            }
          })), ',');
        } else {
          key = item.key;
          value = _.get(data, item.path);
        }
        if (key && value){
          if (_.isArray(value)) {
            //对象数组处理
            if (!_.isString(value[0])){
              result[key] = _.map(value, function (iv) {
                return formatItem(this.AmericaDataStructure().container.descriptionKeys.Harmonized, iv);
              });
            } else {
              result[key] = _.join(value, ';');
            }
          } else {
            result[key] = value;
          }
        }
      });
      return result;
    },
    formatAmericaOthers(othersStr, isImpAmerica){
      if (othersStr) {
        var others = JSON.parse(othersStr);

        //美国进口特殊处理
        if (isImpAmerica){
          others = this.formatAmericaDataItem(this.AmericaDataStructure().others, others);
        }
        return others;
      }
      return null;
    },
    getCompanyParams(companyId,origin) {
      return {
        id: companyId,
        q: this.$paramsService.encode({dataSets:this.processDataSource(origin)})
      };
    },
    processDataSource(origin){
      var source,transitIndex,shipIndex,formatSource;
      source=this.clone(this.session.dataSource);
      transitIndex=0;
      shipIndex=1;
      switch(true){
        case !origin:
        formatSource=processSource(source,null,origin);
        break;
        case origin==1:
        formatSource=processSource(source,shipIndex,origin);
        break;
        case origin==2:
        formatSource=processSource(source,transitIndex,origin);
        break;
      };
      function processSource(source,originIndex,origin){
        if(!origin){
          return source.split('').map((item,index)=>{
            return index==transitIndex||index==shipIndex?0:item
          }).join('');
        }
        return source.split('').map((item,index)=>{
          return index==originIndex?item:0;
        }).join('');
      };
      return formatSource;
    },
    toNewPage(url,target){
      if(!url.includes('http')){
        url='http://'+url;
      }
      window.open(url,target);
    },
    callbackHandler(res){
      if(!this.isEmpty(res.code)){
        return res;
      }else{
        return res.data;
      }
    },
    formatDate(date, format, offset) {
      return dateFormat(date, format, offset);
    },
    transformProps(target,options={},defaultValue){
      const beforeType=this.rawType(options.before);
      const afterType=this.rawType(options.after);
      if(this.rawType(target)!=='Object' || beforeType!==afterType)return target;
      let store=this.cloneObject(target,true),result={};
      if(beforeType==='String'){
        options.before=[options.before];
        options.after=[options.after];
      }
      options.before.forEach((item,index)=>{
        result[options.after[index]]=this.isDef(store[item])?store[item]:defaultValue;
      });
      return result;
    },
    isInteger(obj) {
     return typeof obj === 'number' && obj%1 === 0
    },
    isDef(val){
      return val!==undefined && val!==null;
    },
    //用于比较数组和对象的值和类型是否相等，不包含引用路径
    isEqual(target,compare){
      const targetType=this.rawType(target);
      const compareType=this.rawType(compare);
      if(targetType!==compareType)return false;
      if(targetType==='Array'){
        if(target.length!==compare.length){
          return false;
        }
        for(let i=0,len=target.length;i<len;i++){
          let aType=this.rawType(target[i]);
          let bType=this.rawType(compare[i]);
          if(aType!==bType){
            return false;
          }else{
            if(aType==='Object' || aType==='Array'){
              if(!this.isEqual(target[i],compare[i])){
                return false;
              }
            }else if(target[i]!==compare[i]){
              return false;
            }
          }
        };
        return true;
      };
      if(targetType==='Object'){
        if(Object.keys(target).length !== Object.keys(compare).length){
          return false;
        }
        for(let prop in target){
          const aType=this.rawType(target[prop]);
          const bType=this.rawType(compare[prop]);
          if(aType!==bType){
            return false;
          }
          if(aType==='Object' || aType==='Array'){
            if(!this.isEqual(target[prop],compare[prop])){
              return false;
            }
          }else{
            if(target[prop] !==compare[prop]){
              return false;
            }
          }
        };
        return true;
      };
      return target===compare;
    },
    formatStatus(status) {
      let label;
      switch (status) {
        case 0:
          label = this.$t('CRM_PUBLIC_CUSTOMERS');
          break;
        case 1:
          label = this.$t('CRM_PRIVATE_CUSTOMERS');
          break;
        case 2:
          label = this.$t('CRM_COOPERATIVE_CUSTOMERS');
          break;
      }
      ;
      return label;
    },
    rawType(target) {
      return Object.prototype.toString.call(target).slice(8, -1)
    },
    isArray(val){
      return this.rawType(val)==='Array';
    },
    isObject(val){
      return this.rawType(val)==='Object';
    },
    isString(val){
      return this.rawType(val)==='String';
    },
    isNumber(val){
      return this.rawType(val)==='Number';
    },
    isDef(val){
      return val!==null && val!==undefined;
    },
    clone(target,deep=false){
      const type=this.rawType(target);
      let result;
      switch(type){
        case 'Object':
        result=this.cloneObject(target,deep);
        break;
        case 'Array':
        result=target.slice();
        break;
        default:
        result=target;
        break;
      }
      return result;
    },
    cloneObject(target, deep = false) {
      let result = Object.assign({}, target);
      if(deep){
        for (let prop in result) {
          if (Array.isArray(result[prop])) {
            result[prop] = result[prop].slice();
          }
          ;
          if (this.rawType(result[prop]) == 'Object') {
            result[prop] = this.cloneObject(result[prop], deep);
          }
        }
        ;
      }
      return result;
    },
    diffObject(a, b, not = []) {
      if (typeof a !== typeof b || (typeof a == typeof b && typeof a == 'object' && Array.isArray(a))) {
        return b;
      }
      let result = {}, notIn = _.difference(Object.keys(b), Object.keys(a));
      notIn.forEach(item => {
        result[item] = b[item];
      });
      for (let prop in a) {
        if (not.includes(prop)) continue;
        if (this.rawType(a[prop]) === this.rawType(b[prop])) {
          if (Array.isArray(a[prop]) || this.rawType(a[prop]==='Object')) {
            this.isEqual(b[prop], a[prop]) ? '' : (result[prop] = b[prop]);
            continue;
          }
          ;
          if (this.isEmpty(a[prop]) && this.isEmpty(b[prop])) continue;
          a[prop] == b[prop] ? '' : (result[prop] = b[prop]);
        } else {
          result[prop] = b[prop];
        }
      }
      return result;
    },
    //不要用于布尔类型的判断，总是会返回为false,该函数用于判断各类型数据是否为空值
    isEmpty(value){
      const targetType=this.rawType(value);
      const lodashMatched=['Object','Array','Set','Map','Function','String'];
      if(lodashMatched.includes(targetType) || value===null || value===undefined){
        return _.isEmpty(value);
      }else{
        if(targetType==='Number'){
          return !value.toString();
        }
        if(targetType==='Boolean'){
          return false;
        }
      }
    },
    //解决方案2
    capitalizeHandler2(str){
      function makeString(object) {
        if (object == null) return '';
        return '' + object;
      };
      var titleize = function (str) {
        return makeString(str).toLowerCase().replace(/(?:^|\s|-)\S/g, function(c) {
          return c.toUpperCase();
        });
      };
      return str instanceof Array ? str.map(titleize) : titleize(str);
    },
    capitalizeHandler(str,handle=true,saveMark=false){
      if(!handle)return str;
      let result=str;
      var notMatched=[];
      if(this.rawType(str)!=='String')return;
      var regNumber = /\d+/;
      var regCamelCase=/[A-Z]{1}[a-z]+/g;
      if(regNumber.test(str))return str;
      const regCamelWord=result.match(regCamelCase);
      if(!this.isEmpty(regCamelWord)){
        result=result.replace(regCamelCase,function(matchedWord){
          return ' '+matchedWord;
        })
      }else{
        result=_.capitalize(str);
      }
      const marks=[' ','_','-'];
      marks.forEach(mark=>{
        result.includes(mark)?(result=result.split(mark).map(item=>_.capitalize(item)).join(saveMark?mark:' ')):(notMatched.push(mark));
      });
      return result;
    },
    checkMustFieldExistEmpty(target,fields=[]){
      let result=[];
      if(this.rawType(target)!=='Object')return;
      if(this.rawType(fields)!=='Array')return;
      for(let prop in target){
        if(!this.isEmpty(fields) && fields.includes(prop)){
          this.isEmpty(target[prop])?(result.push(prop)):'';
          continue;
        };
        if(this.isEmpty(fields)){
          this.isEmpty(target[prop])?(result.push(prop)):'';
        }
      };
      return this.isEmpty(result)?false:result;
    },
    isTargetFieldsEmpty(target,fields=[]){
      let empty=true;
      for(let prop in target){
        if(!this.isEmpty(fields) && fields.includes(prop)){
          if(!this.isEmpty(target[prop])){
            empty=false;
            break;
          }
          continue;
        };
        if(this.isEmpty(fields)){
          if(!this.isEmpty(target[prop])){
            empty=false;
            break;
          }
        }
      };

      return empty;
    },
    getTargetFields(target={},options=[]){
      if(this.rawType(target)!=='Object')return;
      let result={};
      options.forEach(option=>{
        result[option]=target[option];
      });
      return this.cloneObject(result,true);
    },
    overwriteTargetFields(target,fields){

    },
    trimEmptyFields(target,not=[]){
      let store=this.cloneObject(target,true);
      let result={};
      for(let prop in store){
        if(!this.isEmpty(not) && not.includes(prop)){
          continue;
        }
        this.isEmpty(store[prop])?'':(result[prop]=store[prop]);
      };
      return this.isEmpty(result)?null:result;
    },
    trimSpaces(str){
      return str.replace(/\s/g,'');
    },
    originEmpty(target){
      const rawType=this.rawType(target);
      let result;
      switch (rawType) {
        case 'String':
          result = '';
          break;
        case 'Array':
          result = [];
          break;
        case 'Object':
          for(let prop in target){
            target[prop]=this.originEmpty(target[prop]);
          };
          result=target;
          break;
        default:
          result=null;
          break;
      }
      return result;
    },
    export2Excel(fileName,headers,exportData) {
      require.ensure([], () => {
        const {export_json_to_excel} = require("@/common/excel/Export2Excel");
        const filterVal = _.keys(exportData[0]);
        const data = this.formatJson(filterVal, exportData);
        export_json_to_excel(headers, data, fileName);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    successNotify(message) {
      this.$notify({
        type: 'success',
        title: this.$t('NOTICE'),
        message: message
      })
    },
    warningNotify(message) {
      this.$notify({
        type: 'warning',
        title: this.$t('WARNING'),
        message: message
      })
    },
    errorNotify(message) {
      this.$notify({
        type: 'error',
        title: this.$t('ERROR'),
        message: message
      })
    }
  }
};
export default mixin;



// WEBPACK FOOTER //
// ./src/common/mixins/crmCommonUtils.js